import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { doPost, doGet } from '../../../config/fetchWrapper'
import { urls } from '../../endPoints'

export const GetTourListAction = createAsyncThunk('getTourList', async (arg, { rejectWithValue }) => {
    try {
        const response = await doGet(urls?.getTourList)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

export const GetTourListSlice = createSlice({
    name: 'getTourList',
    initialState: {
        isLoading: false,
        pendingTourItems: [],
        error: null,
    },
    reducers: {
        GetTourListReset: () => {
            return {
                isLoading: false,
                pendingTourItems: false,
                error: null,
                success: false,
            }
        },
    },
    extraReducers: {
        [GetTourListAction.pending]: (state) => {
            state.isLoading = true
            state.error = null
        },
        [GetTourListAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false
            state.pendingTourItems = payload
            state.error = null
        },
        [GetTourListAction.rejected]: (state, { payload }) => {
            state.isLoading = false
            state.error = payload
        },
    },
})

export const RemoveToursAction = createAsyncThunk('removeTours', async (arg, { rejectWithValue }) => {
    try {
        const response = await doPost(urls?.removeTours, arg)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

export const RemoveToursSlice = createSlice({
    name: 'removeTours',
    initialState: {
        isLoading: false,
        tourDetails: {},
        error: null,
    },
    reducers: {
        RemoveToursReset: () => {
            return {
                isLoading: false,
                tourDetails: false,
                error: null,
                success: false,
            }
        },
    },
    extraReducers: {
        [RemoveToursAction.pending]: (state) => {
            state.isLoading = true
            state.error = null
        },
        [RemoveToursAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false
            state.tourDetails = payload
            state.error = null
        },
        [RemoveToursAction.rejected]: (state, { payload }) => {
            state.isLoading = false
            state.error = payload
        },
    },
})

export const { RemoveToursReset } = RemoveToursSlice.actions
export const { GetTourListReset } = GetTourListSlice.actions